import React from 'react';
import { upperFirst } from 'lodash';
import { compose, withPropsOnChange } from 'recompose';
import { Breadcrumbs, Crumb } from 'components/core/BreadcrumbsV2';
import { cleanTitle } from 'utils/title';
import { PAGE_SUB_TYPES } from '@sparefoot/tracking-events';

export const enhance = compose(
	withPropsOnChange(
		['location', 'searchParams'],
		({ location, searchParams, canonicalUrl }) => {
			const { streetAddress, zip } = location;
			const {
				amenity, latitude, longitude, vehicle, neighborhood, subPageType
			} = searchParams;
			const crumbs = [];

			if (subPageType === PAGE_SUB_TYPES.NEIGHBORHOOD_LANDING && neighborhood) {
				crumbs.push(
					<Crumb
						key="neighborhood"
						href={canonicalUrl}
						isLast
						label={cleanTitle(neighborhood)}
					/>
				);
			} else if (subPageType === PAGE_SUB_TYPES.AMENITY_LANDING) {
				crumbs.push(
					<Crumb
						key="amenity"
						href={canonicalUrl}
						isLast
						label={cleanTitle(amenity)}
					/>
				);
			} else if (subPageType === PAGE_SUB_TYPES.VEHICLE_LANDING) {
				crumbs.push(
					<Crumb
						key="vehicle"
						href={canonicalUrl}
						isLast
						label={vehicle === 'rv' ? 'RV' : `${upperFirst(vehicle)} storage`}
					/>
				);
			} else if (subPageType === PAGE_SUB_TYPES.ZIP_LANDING) {
				crumbs.push(
					<Crumb
						key="zip"
						href={canonicalUrl}
						isLast
						label={zip}
					/>
				);
			} else if (streetAddress && !(latitude || longitude)) {
				crumbs.push(
					<Crumb
						key="streetAddress"
						href={canonicalUrl}
						isLast
						label={streetAddress}
					/>
				);
			}


			return ({ crumbs });
		}
	)
);

export default enhance(Breadcrumbs);
